import { Route } from '@angular/router';

export const appRoutes: Route[] = [
    {
        path: 'streaming-login-or-create-identity',
        loadChildren: () =>
            import(
                '@sxm-app/acquisitions/self-pay/features/streaming-login-or-create-identity'
            ).then((m) => m.routes),
    },
    {
        path: 'existing-self-pay-subscription',
        loadChildren: () =>
            import(
                '@sxm-app/acquisitions/self-pay/features/existing-self-pay-subscription'
            ).then((m) => m.routes),
    },
    {
        path: 'ingest',
        loadChildren: () =>
            import('@sxm-app/acquisitions/self-pay/features/ingest').then(
                (m) => m.routes,
            ),
    },
    {
        path: 'vehicle-device-lookup',
        loadChildren: () =>
            import(
                '@sxm-app/acquisitions/self-pay/features/vehicle-device-lookup'
            ).then((m) => m.routes),
    },
    {
        path: 'vehicle-authenticated',
        loadChildren: () =>
            import(
                '@sxm-app/acquisitions/self-pay/features/vehicle-authenticated'
            ).then((m) => m.routes),
    },
    {
        path: 'vehicle-login-or-create-identity',
        loadChildren: () =>
            import(
                '@sxm-app/acquisitions/self-pay/features/vehicle-login-or-create-identity'
            ).then((m) => m.routes),
    },
];
